// Tells us if the cursor is currently at the end of the last
// text node or at the beginning of the first
const isCursorAtBoundary = (editor, forward = false) => {
  const { document, selection } = editor.value
  const { focus } = selection
  const currentElement = editor.getElement()
  const currentText = document.getNode(focus.key)

  return forward
    ? focus.offset === currentText.text.length &&
        currentText.equals(currentElement.getLastText())
    : focus.offset === 0 && currentText.equals(currentElement.getFirstText())
}

const HelperPlugin = () => {
  return {
    commands: {
      insertNodeAt(editor, existingNode, newNode, after = false) {
        const nodeIndex = editor.value.document.nodes.findIndex(n =>
          n.equals(existingNode)
        )

        editor.insertNodeByKey(
          editor.value.document.key,
          nodeIndex + (after ? 1 : 0),
          newNode
        )
      }
    },
    queries: {
      isCursorAtStartingBoundary(editor) {
        return isCursorAtBoundary(editor)
      },
      isCursorAtEndingBoundary(editor) {
        return isCursorAtBoundary(editor, true)
      },
      isNodeType(editor, node, type) {
        return node && node.type === type
      }
    }
  }
}

export default HelperPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/HelperPlugin.js